module.exports = __webpack_public_path__ + "img/rule-close-btn.2ebf4afb.png";